export class MerchantPosCashCountLatestDto {
  merchantId: number;
  cashCount: PosLatestCashCount[];
}

export class PosLatestCashCount {
  posDeviceId: number;
  cashCount: number;
  currencyId: number;
}
